import React, { Component } from "react";
import "./AdminLogin.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import String from "../../../Assets/Localization/local";
import { Link, Redirect } from "react-router-dom";
import validate from "./validation.js";
import { MyTicket_PATH } from "../../../AppConfig";
import RenderField from "../../../Components/Fields/fields";
import Inputs from "./inputSetting";
import { loginRequest } from "../../../Redux/Action/LoginAction";
import logoPart1 from "../../../Assets/Images/logoWihte.png";
import LoadingBar from "react-redux-loading-bar";

import { Container, Row, Col, Form, FormGroup } from "reactstrap";
class Loginpage extends Component {
  constructor() {
    super();
    this.state = {
      selectedOption: "ADMIN",
    };
    this.radioChange = this.radioChange.bind(this);
  }
  radioChange(e) {
    this.setState({
      selectedOption: e.currentTarget.value,
    });
  }

  componentWillMount() {}

  onSubmit = (values) => {
    values.type = this.state.selectedOption === "ADMIN" ? "ADMIN" : "SUB_ADMIN";
    this.props.loginRequest(values, this.props.lang, "admin/signin");
  };

  render() {

    const { handleSubmit } = this.props;
    String.setLanguage(this.props.lang);
    if (this.props.token) {
      return <Redirect to="/MyTicket/Dashboard" />;
    }

    return (
      <div
        className="loginClass"
        style={{ textAlign: "center", color: "white" }}
      >
        <div className="loginClass-2">
          <div className="loading-bar">
            <LoadingBar
              style={{
                height: "3px",
                zIndex: 1250,
                backgroundImage: `linear-gradient(to right, #FF5438, #FF8044)`,
              }}
            />
          </div>
          <div className="OverLay">
            <div className="LoginContainer">
              <div className="LoginForm">
                <img
                  alt="part_one"
                  src={logoPart1}
                  className="img-fluid LogoPartt1Login"
                  style={{ width: "60px", height: "60px", margin: "0 auto" }}
                />
                <Form
                  onSubmit={handleSubmit(this.onSubmit.bind(this))}
                  className="FormContent"
                >
                  {Inputs.map((row, index) => {
                    return (
                      <Container className="w-100 ">
                        <Row>
                          {row.map((element, index) => {
                            return (
                              <div
                                id="login"
                                className={
                                  this.props.lang === "ar"
                                    ? "m-auto col-lg-12 col-md-12 arLang p-0  "
                                    : "m-auto col-lg-12 col-md-12  enLang "
                                }
                              >
                                <Field
                                  type={element.type}
                                  lang={this.props.lang}
                                  name={element.name}
                                  placeholder={
                                    this.props.lang === "en"
                                      ? element.placeholder.en
                                      : element.placeholder.ar
                                  }
                                  component={RenderField}
                                  icone={element.icon}
                                  loginBool={element.loginBool}
                                  label={element.label}
                                />
                              </div>
                            );
                          })}
                        </Row>
                      </Container>
                    );
                  })}

                  <Row className="LoginType">
                    <Col lg="12">
                      <h4
                        style={{
                          textAlign:
                            this.props.lang === "ar" ? "right" : "left",
                          paddingBottom: "20px",
                          fontSize: "25px",
                          color: "white",
                        }}
                        className={
                          this.props.lang === "en"
                            ? "pl-3  muted mt-3"
                            : " pr-3 muted mt-3 "
                        }
                      >
                        {String.UserType}
                      </h4>
                    </Col>
                    <Col
                      lg="6"
                      className={
                        this.props.lang === "en"
                          ? " pl-3 muted "
                          : " pr-3 muted "
                      }
                    >
                      <FormGroup className="d-flex">
                        <input
                          type="radio"
                          id="admin"
                          name="typelogin"
                          value="ADMIN"
                          checked={this.state.selectedOption === "ADMIN"}
                          onChange={this.radioChange}
                          style={{ marginTop: "6px", width: "auto" }}
                        />
                        <label className="mx-2" style={{ color: "white" }}>
                          {String.AdminType}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col
                      lg="6"
                      className={this.props.lang === "en" ? " pl-3" : " pr-3  "}
                    >
                      <FormGroup className="d-flex">
                        <input
                          type="radio"
                          id="subadmin"
                          name="typelogin"
                          value="SUB_ADMIN"
                          checked={this.state.selectedOption === "SUB_ADMIN"}
                          onChange={this.radioChange}
                          style={{ marginTop: "6px", width: "auto" }}
                        />
                        <label className="mx-2" style={{ color: "white" }}>
                          {String.SubAdminType}
                        </label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <button
                    type="submit"
                    onClick={this.onSubmit}
                    value="Login"
                    className="loginBtn px-5"
                  >
                    {String.loginKey}{" "}
                  </button>
                  <Link
                    to={{
                      pathname: `${MyTicket_PATH}MyTicket/forgetpassword`,
                      state: {
                        type: "ADMIN",
                      },
                    }}
                    className="forgetLink pl-4"
                    style={{
                      textAlign:
                        this.props.lang === "ar"
                          ? "right !important"
                          : "center !important",
                      margin: "auto",
                    }}
                  >
                    {String.forgetPasswordKey}
                  </Link>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.userInfo.language,
    token: state.userInfo.token,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loginRequest,
    },
    dispatch
  );
export default reduxForm({
  form: "Loginpage",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(Loginpage));
